import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project",
  "use": "icon-project-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-project\"><defs><style type=\"text/css\"></style></defs><path d=\"M67.03 926.782h890.335V707.736H67.03v219.046zM511.174 758.96H906.14v116.598H511.174V758.96zM67.03 97.788v219.046h890.335V97.788H67.03zM906.141 265.61H512.197v-116.6h393.944v116.6zM67.031 621.808h890.334V402.762H67.03v219.046z m444.143-167.822H906.14v116.598H511.174V453.986z\" p-id=\"2582\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol